import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppName, BusinessProfile } from '@iot-platform/models/common';
import { SidenavMenuBlock } from '@iot-platform/models/i4b';
import { Observable } from 'rxjs';

export abstract class AbstractAppShellService {
  protected router: Router = inject(Router);

  abstract get appName(): AppName;

  abstract getNavigationTree(): Observable<SidenavMenuBlock[]>;

  abstract getCurrentBusinessProfile(): Observable<BusinessProfile>;

  abstract closePreferences(): void;

  abstract openReleaseNotes(): void;

  abstract openChangelog(): void;

  abstract openMyProfile(): void;

  abstract onBusinessProfileReady(businessProfile?: BusinessProfile): void;

  abstract onBusinessProfileChange(): void;

  abstract returnHome(): void;

  shouldCollapseSidenav(): boolean {
    return false;
  }

  handleBusinessProfileChange(): void {
    this.onBusinessProfileChange();
    this.router.navigate(['/']);
  }
}
